import { translate } from 'i18n/jhipster-language';
import { FIELD_CONSTRAINTS } from './field-constraints';
const { TEXT_MIN, TEXT_MAX } = FIELD_CONSTRAINTS;
/** Optional filter text: empty OK; if set, 5–70 characters. */
export function validateOptionalFilterText(value) {
    const t = value?.trim() ?? '';
    if (t === '')
        return null;
    if (t.length < TEXT_MIN)
        return translate('entity.validation.minlength', { min: TEXT_MIN });
    if (t.length > TEXT_MAX)
        return translate('entity.validation.maxlength', { max: TEXT_MAX });
    return null;
}
/** Optional positive integer card id filter. */
export function validateOptionalCardId(value) {
    const t = value?.trim() ?? '';
    if (t === '')
        return null;
    if (!/^\d+$/.test(t))
        return translate('entity.validation.number');
    const n = Number(t);
    if (!Number.isSafeInteger(n) || n <= 0)
        return translate('entity.validation.number');
    return null;
}
/** Start date must not be after end date when both are set. */
export function validateDateRange(start, end) {
    if (!start || !end)
        return null;
    if (start.getTime() > end.getTime()) {
        return translate('entity.validation.dateRange');
    }
    return null;
}
/** Validate multiple date range pairs; returns first error. */
export function validateDateRanges(pairs) {
    for (const { start, end } of pairs) {
        const err = validateDateRange(start, end);
        if (err)
            return err;
    }
    return null;
}
/** Optional description: empty OK; if set, 5–700 characters. */
export function validateOptionalDescription(value) {
    const t = value?.trim() ?? '';
    if (t === '')
        return null;
    if (t.length < TEXT_MIN)
        return translate('entity.validation.minlength', { min: TEXT_MIN });
    if (t.length > FIELD_CONSTRAINTS.DESCRIPTION_MAX) {
        return translate('entity.validation.maxlength', { max: FIELD_CONSTRAINTS.DESCRIPTION_MAX });
    }
    return null;
}
/** Manual validation for required description-style text (5–700 chars). */
export function validateRequiredDescription(value) {
    const t = value.trim();
    if (!t)
        return translate('entity.validation.required');
    if (t.length < TEXT_MIN)
        return translate('entity.validation.minlength', { min: TEXT_MIN });
    if (t.length > FIELD_CONSTRAINTS.DESCRIPTION_MAX) {
        return translate('entity.validation.maxlength', { max: FIELD_CONSTRAINTS.DESCRIPTION_MAX });
    }
    return null;
}
